import { formatCompactDisplayDate } from '@crm/shared/lib';

export const DealCardDate = ({ date }: { date: string }) => (
    <span className="text-right min-w-20.5">{formatCompactDisplayDate(new Date(date))}</span>
);
